import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { InfoComponent } from '../../objects/info/info/info.component';
import { FormaPago } from 'src/app/Models/planilla/forma-pago';
import { DataService } from 'src/app/Service/data.service';

@Component({
  selector: 'app-formas-de-pago',
  templateUrl: './formas-de-pago.component.html',
  styleUrls: ['./formas-de-pago.component.css']
})
export class FormasDePagoComponent implements OnInit {

  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;

  public search    = '';
  public page: any;
  public total     = 0;
  public items: FormaPago[] = [];
  public nuevo: FormaPago   = new FormaPago();
  public agregando          = false;
  private _backup: {[id: number]: any} = {};

  constructor(private data: DataService, private title: Title) {}

  ngOnInit() {
    this.title.setTitle('Formas de Pago | Sistema');
    this.GetData();
  }

  GetData() {
    this.loading.show('Cargando...');
    this.items = [];
    const req = this.search
      ? this.data.GetFromValue(this.data.api.forma_pago, 'nombre__icontains', this.search)
      : this.data.GetSimple(this.data.api.forma_pago);
    req.subscribe(
      r => { this.loading.hide(); this.items = r; this.total = r.length; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowNew()   { this.nuevo = new FormaPago(); this.agregando = true; }
  CancelNew() { this.agregando = false; this.nuevo = new FormaPago(); }
  formNewValid(): boolean { return !!(this.nuevo.codigo && this.nuevo.nombre); }

  SaveNew() {
    this.loading.show('Registrando...');
    this.data.Post(this.data.api.forma_pago, this.nuevo).subscribe(
      r => { this.loading.hide(); this.agregando = false; this.nuevo = new FormaPago(); this.GetData(); },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  StartEdit(item: FormaPago)  { this._backup[item.idformapago] = { ...item }; item.editando = true; }
  CancelEdit(item: FormaPago) { Object.assign(item, this._backup[item.idformapago]); item.editando = false; }

  SaveEdit(item: FormaPago) {
    this.loading.show('Actualizando...');
    this.data.Put(this.data.api.forma_pago, `${item.idformapago}`, item).subscribe(
      r => { this.loading.hide(); item.editando = false; delete this._backup[item.idformapago]; },
      e => { this.loading.hide(); this.info.error(e, () => {}); }
    );
  }

  ShowDelete(item: FormaPago) {
    this.info.show(`¿Deseas eliminar la forma de pago "${item.nombre}"?`, 1, null,
      { cancelText: 'No, Cancelar', successText: 'Sí, Eliminar', isCancel: true },
      () => this.Delete(item), () => { this.info.hide(); }, 20);
  }

  Delete(item: FormaPago) {
    this.loading.show('Eliminando...');
    this.data.Delete(this.data.api.forma_pago, `${item.idformapago}`).subscribe(
      r => { this.loading.hide(); this.info.show(r.message, 2, null, null, () => { this.info.hide(); this.GetData(); }); },
      e => { this.loading.hide(); this.info.error(e, () => this.info.hide()); }
    );
  }
}
